import { PRODUCT_LIST_REQUEST,
         PRODUCT_LIST_SUCCESS,
         PRODUCT_LIST_FAIL ,

         PRODUCT_DETAILS_REQUEST,
         PRODUCT_DETAILS_SUCCESS,
         PRODUCT_DETAILS_FAIL,
         
         CUSTOMER_LIST_REQUEST,
         CUSTOMER_LIST_SUCCESS,
         CUSTOMER_LIST_FAIL,

         CUSTOMER_POSTLIST_REQUEST,
         CUSTOMER_POSTLIST_SUCCESS,
         CUSTOMER_POSTLIST_FAIL,

         CUSTOMER_DETAILS_REQUEST,
         CUSTOMER_DETAILS_SUCCESS,
         CUSTOMER_DETAILS_FAIL,
         
         CUSTOMER_UPDATE_REQUEST,
         CUSTOMER_UPDATE_SUCCESS,
         CUSTOMER_UPDATE_FAIL,

         CATEGORY_LIST_REQUEST,
         CATEGORY_LIST_SUCCESS,
         CATEGORY_LIST_FAIL,
       } from "../constants/productConstansts"


export const listProductReducers = (state = {products:[]} , action) => {
    switch(action.type){
        case PRODUCT_LIST_REQUEST:
            return { products: [] , loading: true}
        case PRODUCT_LIST_SUCCESS:
            return { products: action.payload , loading: false}
        case PRODUCT_LIST_FAIL:
            return { error: action.payload , loading: false}
        default:
            return state

    }

}


export const detailsProductReducers = (state = {product:{reviews:[]}} , action) => {
    switch(action.type){
        case PRODUCT_DETAILS_REQUEST:
            return { ...state , loading: true}
        case PRODUCT_DETAILS_SUCCESS:
            return { product: action.payload , loading: false}
        case PRODUCT_DETAILS_FAIL:
            return { error: action.payload , loading: false}
        default:
            return state

    }

}

export const listCategoryReducers = (state = {categories:[]} , action) => {
    switch(action.type){
        case CATEGORY_LIST_REQUEST:
            return { categories: [] , loading: true}
        case CATEGORY_LIST_SUCCESS:
            return { categories: action.payload , loading: false}
        case CATEGORY_LIST_FAIL:
            return { error: action.payload , loading: false}
        default:
            return state

    }

}



export const listPaidCustomerReducers = (state = {paidCustomer:[]} , action) => {
    switch(action.type){
        case CUSTOMER_LIST_REQUEST:
            return { paidCustomer: [] , loading: true}
        case CUSTOMER_LIST_SUCCESS:
            return { paidCustomer: action.payload , loading: false}
        case CUSTOMER_LIST_FAIL:
            return { error: action.payload , loading: false}
        default:
            return state

    }

}

export const listPostCustomerReducers = (state = {postCustomer:[]} , action) => {
    switch(action.type){
        case CUSTOMER_POSTLIST_REQUEST:
            return { postCustomer: [] , loading: true}
        case CUSTOMER_POSTLIST_SUCCESS:
            return { postCustomer: action.payload , loading: false}
        case CUSTOMER_POSTLIST_FAIL:
            return { error: action.payload , loading: false}
        default:
            return state

    }

}


export const detailsCustomerReducers = (state = {customers:{reviews:[]}} , action) => {
    switch(action.type){
        case CUSTOMER_DETAILS_REQUEST:
            return { ...state , loading: true}
        case CUSTOMER_DETAILS_SUCCESS:
            return { customers: action.payload , loading: false}
        case CUSTOMER_DETAILS_FAIL:
            return { error: action.payload , loading: false}
        default:
            return state

    }

}




export const updateCustomerReducers = (state = {updateThisCustomer:[]} , action) => {
    switch(action.type){
        case CUSTOMER_UPDATE_REQUEST:
            return { updateThisCustomer: [] , loading: true}
        case CUSTOMER_UPDATE_SUCCESS:
            return { updateThisCustomer: action.payload , loading: false}
        case CUSTOMER_UPDATE_FAIL:
            return { error: action.payload , loading: false}
        default:
            return state

    }

}








